import Modal from "components/DesignSystem/Modal/Modal";
import { AddProductModalContent } from "components/MyProducts/ProductFormModal";
import { useModal } from "hooks/useModal";
import { useState } from "react";
import { InvoiceItem } from "types/Models/invoice";
import {
  ProductAndServices,
  ProductAndServicesDetail,
} from "types/Models/productAndServices";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";

export const ItemWrapper = ({
  children,
  invoiceItem,
  onNewProductCreateSuccess,
}: {
  children: ({
    isCustomInput,
    onChange,
  }: {
    isCustomInput: boolean;
    onChange: ({ checked }: { checked: boolean }) => void;
    createNewProduct: (inputValue: string) => void;
    addNewProductAndServicesModal: () => void;
  }) => React.ReactNode;
  invoiceItem: InvoiceItem;
  onNewProductCreateSuccess: ({
    item,
  }: {
    item: ProductAndServicesDetail;
  }) => void;
}) => {
  const { values } = useTypedFormikContext<InvoiceItem>();
  const isCustomInput = Boolean(values.description && !values.product_data_id);
  const [newProductName, setNewProductName] = useState<string>("");
  const addProductAndServicesModal = useModal();

  const onChange = ({ checked }: { checked: boolean }) => {};

  const createNewProduct = (inputValue: string) => {
    setNewProductName(inputValue);
    addProductAndServicesModal.open();
  };

  const handleClose = () => {
    addProductAndServicesModal.close();
    setNewProductName("");
  };

  return (
    <>
      {children({
        isCustomInput,
        onChange,
        createNewProduct,
        addNewProductAndServicesModal: addProductAndServicesModal.open,
      })}
      <Modal.Root
        open={addProductAndServicesModal.isOpen}
        onOpenChange={addProductAndServicesModal.close}
        modal={false}
      >
        <AddProductModalContent
          onSuccess={({ item }) => {
            onNewProductCreateSuccess({ item });
          }}
          name={newProductName}
          close={handleClose}
        />
      </Modal.Root>
    </>
  );
};
